<template>
  <div id="login">
    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>
            <div class="version abs blanco fpG">
              {{this.$store.state.version}}
            </div>
            <div class="row forms no-gutters">
              <div class="col-4">
                <div class="botonera">
                  <ul>
                    <li :class="{ active: showLoginForm }">
                      <button class="ls6 lighter" @click="toggleForm()">
                        LOGIN
                      </button>
                    </li>
                    <li :class="{ active: showLoginForm === false }">
                      <button class="ls6 lighter" @click="toggleForm()">
                        REGISTRO
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-8">
                <form v-if="showLoginForm" @submit="login($event)">
                  <div class="pb4 px-2">
                    <div class="w-100">
                      <input
                        v-model.trim="loginForm.email"
                        type="email"
                        placeholder="Email"
                        id="email1"
                        required
                      />
                    </div>
                    <div class="w-100">
                      <input
                        v-model.trim="loginForm.password"
                        type="password"
                        placeholder="Contraseña"
                        id="password1"
                        required
                      />
                    </div>

                    <div class="w-100 text-center">
                      <button type="submit" class="btn-generico">ENTRAR</button>
                    </div>
                  </div>

                  <div class="extras text-center pb3 lighter">
                    <a @click="togglePasswordReset()" class="pointer amarillo"
                      >Olvidé mi contraseña</a
                    >
                  </div>
                  <div class="extras2 text-center cyan pb5 mb5 lighter">
                    Si aún no tienes cuenta,
                    <a @click="toggleForm()" class="amarillo bold pointer"
                      >adquiere ya una membresía</a
                    >
                  </div>

                  <div class="extras2 text-center cyan pb5 mb5 lighter">
                    <a @click="showPricingModal()" class="amarillo bold pointer"
                      >Precio y suscripción</a
                    >
                  </div>

                  <div class="extras2 text-center cyan pb5 mb5 lighter">
                    <a @click="showPolitica()" class="amarillo bold pointer"
                      >Política de Reembolsos Encauce </a
                    >
                  </div>

                  <!-- <div class="text-center cyan lighter pb4">CONTINUAR CON</div> -->
                  <!-- <div class="d-flex justify-content-center align-items-center">
                    <div>
                      <button @click="loginFacebook()"  type="button" class="btnfacebook mx3">
                        <span class="px3">
                          <svg
                            enable-background="new 0 0 512 512"
                            id="Layer_1"
                            version="1.1"
                            viewBox="0 0 512 512"
                            width="2.5vw"
                            height="2.5vw"
                            xml:space="preserve"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <path
                              d="M288,512h-96V256h-64v-96h64V96c0-70.737,12.656-96,96-96h96v96h-64c-32.469,0-32,9.387-32,32v32h96l-32,96  l-63.359-1.006L288,512z"
                              fill="#ffffff"
                            />
                          </svg>
                        </span>
                        <span class="px3">Facebook</span>
                      </button>
                    </div>
                    <div>
                      <button @click="loginGoogle()" type="button" class="btngoogle mx3">
                        <span class="px3">
                          <svg
                            id="Layer_1"
                            style="enable-background:new 0 0 512 512;"
                            version="1.1"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="2.5vw"
                            height="2.5vw"
                          >
                            <path
                              fill="#ffffff"
                              d="M491.4,210.1c-76.8,0-153.6,0-230.5,0c0,31.9,0,63.7,0,95.6c44.5,0,89,0,133.5,0c-5.2,30.5-23.3,58.5-49,75.6  c-16.2,10.9-34.8,17.9-53.9,21.3c-19.3,3.3-39.2,3.7-58.4-0.2c-19.6-3.9-38.2-12.1-54.5-23.5c-26-18.3-45.9-45.1-56.1-75.2  c-10.4-30.6-10.5-64.8,0-95.4c7.3-21.6,19.5-41.5,35.5-57.7c19.8-20.2,45.5-34.7,73.1-40.6c23.7-5.1,48.7-4.1,71.9,2.9  c19.7,6,37.9,16.8,52.8,31c15.1-15,30-30,45.1-45c7.9-8.1,16.2-15.8,23.8-24.1c-22.8-21.1-49.6-38.1-78.8-48.8  c-52.6-19.4-112-19.8-165-1.4C121.1,45,70.3,89.6,42.1,146.1c-9.8,19.4-17,40.2-21.3,61.6C10,260.8,17.5,317.5,42.1,366  c15.9,31.6,38.8,59.7,66.5,81.8c26.2,20.9,56.7,36.3,89,44.9c40.8,10.9,84.2,10.7,125.3,1.3c37.1-8.5,72.2-26.3,100.3-52.2  c29.6-27.2,50.8-63.1,62-101.7C497.3,298.1,499,253.2,491.4,210.1z"
                            />
                          </svg>
                        </span>
                        <span class="px3">Google</span>
                      </button>
                    </div>
                  </div> -->
                </form>

                <form v-else @submit="signup($event)">
                  <div class="row px-2">
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.membresia_id"
                        type="text"
                        placeholder="ID Membresía"
                        id="membresia"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.nombre"
                        type="text"
                        placeholder="Nombre"
                        id="nombre"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.apellido"
                        type="text"
                        placeholder="Apellido"
                        id="apellido"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.email"
                        type="email"
                        placeholder="Email"
                        id="email2"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <select name="estado" v-model.trim="signupForm.genero">
                        <option value="">Género</option>
                        <option value="femenino">Femenino</option>
                        <option value="masculino">Masculino</option>
                      </select>
                    </div>
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.celular"
                        type="text"
                        placeholder="Celular (10 dígitos)"
                        id="celular"
                        maxlength="10"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.password"
                        type="password"
                        placeholder="Contraseña"
                        id="password2"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <input
                        v-model.trim="signupForm.fecha_nacimiento"
                        :type="dateType"
                        placeholder="Fecha de nacimiento"
                        id="fecha_nacimiento"
                        @click="cambiaFechaType()"
                        @focus="cambiaFechaType()"
                        required
                      />
                    </div>
                    <div class="col-12">
                      <select name="estado" v-model.trim="signupForm.estado">
                        <option value="">Estado</option>
                        <option value="Aguascalientes">Aguascalientes</option>
                        <option value="Baja California">Baja California</option>
                        <option value="Baja California Sur">
                          Baja California Sur
                        </option>
                        <option value="Campeche">Campeche</option>
                        <option value="Chiapas">Chiapas</option>
                        <option value="Chihuahua">Chihuahua</option>
                        <option value="CDMX">Ciudad de México</option>
                        <option value="Coahuila">Coahuila</option>
                        <option value="Colima">Colima</option>
                        <option value="Durango">Durango</option>
                        <option value="Estado de México">
                          Estado de México
                        </option>
                        <option value="Guanajuato">Guanajuato</option>
                        <option value="Guerrero">Guerrero</option>
                        <option value="Hidalgo">Hidalgo</option>
                        <option value="Jalisco">Jalisco</option>
                        <option value="Michoacán">Michoacán</option>
                        <option value="Morelos">Morelos</option>
                        <option value="Nayarit">Nayarit</option>
                        <option value="Nuevo León">Nuevo León</option>
                        <option value="Oaxaca">Oaxaca</option>
                        <option value="Puebla">Puebla</option>
                        <option value="Querétaro">Querétaro</option>
                        <option value="Quintana Roo">Quintana Roo</option>
                        <option value="San Luis Potosí">San Luis Potosí</option>
                        <option value="Sinaloa">Sinaloa</option>
                        <option value="Sonora">Sonora</option>
                        <option value="Tabasco">Tabasco</option>
                        <option value="Tamaulipas">Tamaulipas</option>
                        <option value="Tlaxcala">Tlaxcala</option>
                        <option value="Veracruz">Veracruz</option>
                        <option value="Yucatán">Yucatán</option>
                        <option value="Zacatecas">Zacatecas</option>
                      </select>
                    </div>
                    <!-- <div class="col-12">
                      <select name="institucion" v-model.trim="signupForm.tipo_usuario" required >
                        <option value="">Tipo de membresía: </option>
                        <option value="Instituto, escuela, bachiller u otro">Instituto, escuela, bachiller u otro </option>
                        <option value="No soy estudiante">No soy estudiante</option>
                      </select>
                    </div>
                    <div class="col-12" v-if="signupForm.tipo_usuario == 'Instituto, escuela, bachiller u otro'">
                      <select name="institucion" v-model.trim="signupForm.institucion" required @change="signupForm.salon = ''">
                        <option value="">Institución</option>
                        <option value="Instituto Cultural">Instituto Cultural</option>
                        <option value="Cetmar Nº 9">Cetmar Nº 9</option>
                      </select>
                    </div> -->
                    <!-- <div class="col-12">
                      <select name="turno" v-model.trim="signupForm.turno" @change="signupForm.salon = ''" required>
                        <option value="">Turno</option>
                        <option value="Matutino">Matutino</option>
                        <option value="Vespertino">Vespertino</option>
                      </select>
                    </div> -->
                    <!-- <div class="col-12">
                      <select name="salon" v-model.trim="signupForm.salon"  required>
                        <option value="">Salón</option>
                        <option value="4A">4A</option>
                        <option value="4B">4B</option>
                        <option value="5A">5A</option>
                        <option value="5B">5B</option>
                        <option value="6A">6A</option>
                        <option value="6B">6B</option>
                      </select>

                      
                     
                    </div> -->
                    <!-- <div class="col-12">
                      <input
                        v-model.trim="signupForm.pasatiempo"
                        type="text"
                        placeholder="Pasatiempo"
                        id="pasatiempo"
                        required
                      />
                    </div> -->
                  </div>
                  <div class="row pb4">
                    <div class="col-12 text-center">
                      <div class="w-100 text-center">
                        <button type="submit" class="btn-generico">
                          REGISTRARME
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="text-center cyan lighter pb4">CONTINUAR CON</div>
                  <div class="d-flex justify-content-center align-items-center">
                    <div>
                      <button @click="loginFacebook()"  type="button" class="btnfacebook mx3">
                        <span class="px3">
                          <svg
                            enable-background="new 0 0 512 512"
                            id="Layer_1"
                            version="1.1"
                            viewBox="0 0 512 512"
                            width="2.5vw"
                            height="2.5vw"
                            xml:space="preserve"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <path
                              d="M288,512h-96V256h-64v-96h64V96c0-70.737,12.656-96,96-96h96v96h-64c-32.469,0-32,9.387-32,32v32h96l-32,96  l-63.359-1.006L288,512z"
                              fill="#ffffff"
                            />
                          </svg>
                        </span>
                        <span class="px3">Facebook</span>
                      </button>
                    </div>
                    <div>
                      <button @click="loginGoogle()" type="button" class="btngoogle mx3">
                        <span class="px3">
                          <svg
                            id="Layer_1"
                            style="enable-background:new 0 0 512 512;"
                            version="1.1"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="2.5vw"
                            height="2.5vw"
                          >
                            <path
                              fill="#ffffff"
                              d="M491.4,210.1c-76.8,0-153.6,0-230.5,0c0,31.9,0,63.7,0,95.6c44.5,0,89,0,133.5,0c-5.2,30.5-23.3,58.5-49,75.6  c-16.2,10.9-34.8,17.9-53.9,21.3c-19.3,3.3-39.2,3.7-58.4-0.2c-19.6-3.9-38.2-12.1-54.5-23.5c-26-18.3-45.9-45.1-56.1-75.2  c-10.4-30.6-10.5-64.8,0-95.4c7.3-21.6,19.5-41.5,35.5-57.7c19.8-20.2,45.5-34.7,73.1-40.6c23.7-5.1,48.7-4.1,71.9,2.9  c19.7,6,37.9,16.8,52.8,31c15.1-15,30-30,45.1-45c7.9-8.1,16.2-15.8,23.8-24.1c-22.8-21.1-49.6-38.1-78.8-48.8  c-52.6-19.4-112-19.8-165-1.4C121.1,45,70.3,89.6,42.1,146.1c-9.8,19.4-17,40.2-21.3,61.6C10,260.8,17.5,317.5,42.1,366  c15.9,31.6,38.8,59.7,66.5,81.8c26.2,20.9,56.7,36.3,89,44.9c40.8,10.9,84.2,10.7,125.3,1.3c37.1-8.5,72.2-26.3,100.3-52.2  c29.6-27.2,50.8-63.1,62-101.7C497.3,298.1,499,253.2,491.4,210.1z"
                            />
                          </svg>
                        </span>
                        <span class="px3">Google</span>
                      </button>
                    </div>
                  </div> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>
    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        membresia_id: "",
        nombre: "",
        apellido: "",
        email: "",
        genero: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        estado: "",
        tipo_usuario: "",
        institucion: "",
        turno: "",
        salon: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
    };
  },
  mounted: function () {
    //oculta barra de navegación
    //window.scrollTo(0,1);

    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    showPricingModal() {
      swal.fire({
        title: "Precio y Suscripción",
        text: "Nuestras pruebas se venden de forma unitaria, y el usuario puede elegir la cantidad de pruebas que desea adquirir al valor unitario único de USD 25.00 o MXN 502.26. La prueba se vende por un solo valor, no es una suscripción recurrente y se ofrece bajo demanda del cliente. En caso de cambios en los precios, estos serán notificados previamente y reflejados al momento de la compra.",
        icon: "info",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#3085d6",
      });
    },
    showPolitica() {
      swal.fire({
        title: "Política de Reembolsos Encauce",
        html: `<p style="text-align: justify;">
      En Encauce, estamos comprometidos con la satisfacción de nuestros clientes. Ofrecemos servicios de pruebas vocacionales diseñados para proporcionar a cada usuario un valor educativo significativo. Sin embargo, entendemos que puede haber situaciones en las que necesites solicitar un reembolso. Nuestra política de reembolso está diseñada para garantizar claridad y transparencia en todo momento.
      <br><br>
      <strong>1. Elegibilidad para Reembolsos</strong><br>
      Los reembolsos son elegibles solo en el caso de que el servicio no haya sido utilizado en su totalidad. Esto incluye si no has completado la prueba vocacional. Los reembolsos solo se otorgan dentro de los 14 días posteriores a la fecha de compra. No se realizarán reembolsos para servicios que ya hayan sido completados, descargados o para los cuales se haya entregado un informe.
      <br><br>
      <strong>2. Proceso de Solicitud de Reembolso</strong><br>
      Para solicitar un reembolso, debes ponerte en contacto con nuestro equipo de soporte en <a href="mailto:soporte@encaucetotal.com">soporte@encaucetotal.com</a> y proporcionar: Nombre completo, Dirección de correo electrónico registrada, Número de pedido o referencia de pago, Motivo de la solicitud de reembolso.
      <br><br>
      <strong>3. Evaluación de la Solicitud</strong><br>
      Una vez recibida la solicitud, nuestro equipo la revisará en un plazo de 5 días hábiles. En algunos casos, es posible que solicitemos información adicional para procesar tu solicitud. Si la solicitud cumple con los requisitos para un reembolso, el monto se reembolsará a la forma de pago original en un plazo de hasta 10 días hábiles.
      <br><br>
      <strong>4. Excepciones y Reembolsos Parciales</strong><br>
      Si solo se ha utilizado una parte del servicio, podemos ofrecer reembolsos parciales a nuestra discreción. No se ofrecerán reembolsos si se han violado los términos de servicio o si se detecta un uso fraudulento de la plataforma.
      <br><br>
      <strong>5. Pagos</strong><br>
      Todos los pagos y reembolsos son procesados a través de un aliado, y cualquier reembolso está sujeto a los términos y condiciones de nuestro aliado de procesamiento. El tiempo de procesamiento del reembolso puede variar según la institución bancaria.
      <br><br>
      <strong>6. Modificaciones a la Política de Reembolso</strong><br>
      Encauce se reserva el derecho de modificar esta política de reembolso en cualquier momento. Cualquier cambio será notificado en la plataforma y entrará en vigencia inmediatamente.
    </p>`,        icon: "info",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#3085d6",
      });
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "2000-01-01";
    },
    toggleForm() {
      this.$router.push('/market');
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.registro();
    },
    async registro(monedero = "") {
      console.log({ registro: this.signupForm });
      await this.$store.dispatch("signup", this.signupForm);

      this.showMonedero = false;
      this.resetForm();
      this.toggleForm();
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
